import { PRIORITET_LABELS, PRIORITET_COLORS, getInitials } from '../../lib/format';
import type { Prioritet } from '../../lib/types';
import { clsx } from 'clsx';

interface PriorityProps {
  prioritet: Prioritet;
}

export function PriorityBadge({ prioritet }: PriorityProps) {
  return (
    <span className={clsx('chip', PRIORITET_COLORS[prioritet])}>
      {PRIORITET_LABELS[prioritet]}
    </span>
  );
}

interface AvatarProps {
  navn: string;
  avatarUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

export function Avatar({ navn, avatarUrl, size = 'sm' }: AvatarProps) {
  const sizeClass = {
    sm: 'h-7 w-7 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-16 w-16 text-xl',
  }[size];

  if (avatarUrl) {
    return <img src={avatarUrl} alt={navn} className={clsx('rounded-full object-cover', sizeClass)} />;
  }

  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-full bg-brand-100 font-medium text-brand-700',
        sizeClass,
      )}
    >
      {getInitials(navn || '?')}
    </div>
  );
}
